import RequestStatus from '../model/RequestStatus';
import GetBannerContentResponse from 'src/model/BannerContent';
import {
  GetBannerContentQueryComplete,
  BANNER_CONTENT_QUERY_FAILED,
  BANNER_CONTENT_QUERY_START,
  BANNER_CONTENT_QUERY_SUCCESS,
} from 'src/actions/BannerContentAction';

const initialState: GetBannerContentResponse = {
  requestStatus: RequestStatus.NOT_LOADED,
  data: null,
};

export default (
  state: GetBannerContentResponse = initialState,
  action: GetBannerContentQueryComplete,
): GetBannerContentResponse => {
  switch (action.type) {
    case BANNER_CONTENT_QUERY_START:
      return {
        requestStatus: RequestStatus.LOADING,
        data: state.data,
      };
    case BANNER_CONTENT_QUERY_SUCCESS:
      return {
        requestStatus: RequestStatus.SUCCESS,
        data: action.bannerContentList,
      };
    case BANNER_CONTENT_QUERY_FAILED:
      return {
        requestStatus: RequestStatus.ERROR,
        data: null,
      };
    default:
      return state;
  }
};
